import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const deleteUserTodo = createAsyncThunk('deleteUser', async (data) => {
    try {
        const res = await axios({
            method: "delete",
            url: process.env.REACT_APP_API_URL + `user/${data}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('token') }
        })
        return res

    } catch (error) {
        return error?.response
    }
})




